import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

const Footer = () => {
  return (
    <div className="overflow-x-hidden max-w-screen font-poppins bg-gradient-to-r from-blue-600 to-indigo-600">
      {/* Combined Footer Top & Bottom */}
      <div className="bg-gray-900 px-8 py-10">
        <div className="sm:flex justify-between items-center">
          {/* Footer Top Left */}
          <div className="text-white">
            <h1 className="text-3xl font-bold cursor-pointer text-blue-400">
              Etablissement Rose
            </h1>
            <p className="py-4 max-w-lg">
              Nous sommes ravis de vous accueillir dans l’univers de l’énergie solaire et des solutions durables ! Chez ETS ROSE, nous croyons en un avenir où chaque foyer, entreprise et communauté a accès à une énergie propre, fiable et abordable.
            </p>
          </div>
          {/* Footer Top Right */}
          <div className="mt-8 sm:mt-0 text-white text-center">
            <h1 className="text-2xl font-bold py-2">
            Apportons plus de lumière et d’espoir au monde
            </h1>
            <button
              onClick={() => window.open('https://wa.me/25779951372', '_blank')}
              className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded transition transform hover:scale-105 flex items-center gap-2 shadow-lg hover:shadow-xl"
            >
              <FaWhatsapp />
              WhatsApp
            </button>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 px-8 py-10">
        <div className="flex flex-col md:flex-row justify-around items-center gap-6">
          {/* Location Card */}
          <div className="flex items-center space-x-4 bg-blue-500/20 p-6 rounded-lg hover:shadow-lg transition shadow-blue-300">
            <div className="flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full">
              <svg width="20" height="20" viewBox="0 0 24 24" className="fill-current text-blue-400">
                <path d="M21.8182 24H16.5584C15.3896 24 14.4156 23.0256 14.4156 21.8563V17.5688C14.4156 17.1401 14.0649 16.7893 13.6364 16.7893H10.4026C9.97403 16.7893 9.62338 17.1401 9.62338 17.5688V21.8173C9.62338 22.9866 8.64935 23.961 7.48052 23.961H2.14286C0.974026 23.961 0 22.9866 0 21.8173V8.21437C0 7.62972 0.311688 7.08404 0.818182 6.77223L11.1039 0.263094C11.6494 -0.0876979 12.3896 -0.0876979 12.9351 0.263094L23.2208 6.77223C23.7273 7.08404 24 7.62972 24 8.21437V21.7783C24 23.0256 23.026 24 21.8182 24Z" />
              </svg>
            </div>
            <div>
              <h4 className="text-gray-200 text-xl font-bold">Notre emplacement</h4>
              <p className="text-gray-400 text-base">
                Province et commune, Kirundo centre, route Bugabira, quartier MUNANIRA
              </p>
            </div>
          </div>
          {/* Phone Card */}
          <div className="flex items-center space-x-4 bg-blue-500/20 p-6 rounded-lg hover:shadow-lg transition shadow-blue-300">
            <div className="flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full">
              <svg width="20" height="20" viewBox="0 0 24 26" className="fill-current text-blue-400">
                <path d="M22.6149 15.1386C22.5307 14.1704 21.7308 13.4968 20.7626 13.4968H2.82869C1.86042 13.4968 1.10265 14.2125 0.97636 15.1386L0.092295 23.9793C0.0501967 24.4845 0.21859 25.0317 0.555377 25.4106C0.892163 25.7895 1.39734 26 1.94462 26H21.6887C22.1939 26 22.6991 25.7895 23.078 25.4106C23.4148 25.0317 23.5832 24.5266 23.5411 23.9793L22.6149 15.1386ZM21.9413 24.4424C21.8992 24.4845 21.815 24.5687 21.6466 24.5687H1.94462C1.81833 24.5687 1.69203 24.4845 1.64993 24.4424C1.60783 24.4003 1.52364 24.3161 1.56574 24.1477L2.4498 15.2649C2.4498 15.0544 2.61819 14.9281 2.82869 14.9281H20.8047C21.0152 14.9281 21.1415 15.0544 21.1835 15.2649L22.0676 24.1477C22.0255 24.274 21.9834 24.4003 21.9413 24.4424Z" />
                <path d="M11.7965 16.7805C10.1547 16.7805 8.84961 18.0855 8.84961 19.7273C8.84961 21.3692 10.1547 22.6742 11.7965 22.6742C13.4383 22.6742 14.7434 21.3692 14.7434 19.7273C14.7434 18.0855 13.4383 16.7805 11.7965 16.7805ZM11.7965 21.2008C10.9966 21.2008 10.3231 20.5272 10.3231 19.7273C10.3231 18.9275 10.9966 18.2539 11.7965 18.2539C12.5964 18.2539 13.2699 18.9275 13.2699 19.7273C13.2699 20.5272 12.5964 21.2008 11.7965 21.2008Z" />
              </svg>
            </div>
            <div>
              <h4 className="text-gray-200 text-xl font-bold">Phone Number</h4>
              <p className="text-gray-400 text-base">(+257) 79 951 372 / 69 932 400</p>
            </div>
          </div>
          {/* Email Card */}
          <div className="flex items-center space-x-4 bg-blue-500/20 p-6 rounded-lg hover:shadow-lg transition shadow-blue-300">
            <div className="flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-full">
              <svg width="24" height="20" viewBox="0 0 28 19" className="fill-current text-blue-400">
                <path d="M25.3636 0H2.63636C1.18182 0 0 1.16785 0 2.6052V16.3948C0 17.8322 1.18182 19 2.63636 19H25.3636C26.8182 19 28 17.8322 28 16.3948V2.6052C28 1.16785 26.8182 0 25.3636 0ZM25.3636 1.5721C25.5909 1.5721 25.7727 1.61702 25.9545 1.75177L14.6364 8.53428C14.2273 8.75886 13.7727 8.75886 13.3636 8.53428L2.04545 1.75177C2.22727 1.66194 2.40909 1.5721 2.63636 1.5721H25.3636ZM25.3636 17.383H2.63636C2.09091 17.383 1.59091 16.9338 1.59091 16.3499V3.32388L12.5 9.8818C12.9545 10.1513 13.4545 10.2861 13.9545 10.2861C14.4545 10.2861 14.9545 10.1513 15.4091 9.8818L26.3182 3.32388V16.3499C26.4091 16.9338 25.9091 17.383 25.3636 17.383Z" />
              </svg>
            </div>
            <div>
              <h4 className="text-gray-200 text-xl font-bold">Email Address</h4>
              <p className="text-gray-400 text-base">rosemwiha.etsegide@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="mt-8">
          <div className="h-px bg-gray-100/20"></div>
          <p className="pt-4 text-center text-gray-200/40 text-sm">
            All Rights Reserved 2025 - <button onClick={() => window.open('https://hyphentech.tech', '_blank')} className="cursor-pointer text-blue-400 hover:text-blue-300 bg-transparent border-none p-0">@Hyphen Tech</button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer